import type { WorkerMetricTone } from '@insolitum/types';

/**
 * Wydźwięk metryki → paleta POWŁOKI.
 *
 * `@insolitum/utils` zwraca sam wydźwięk (`good` / `warn` / `bad` / `neutral`)
 * i nie zna żadnych klas CSS — celowo, bo Temperatio maluje ten sam „good"
 * cyjanem, a Aegis bursztynem. Tłumaczenie na kolor jest lokalne dla każdej
 * aplikacji i to jest jedyne miejsce, w którym powłoka je robi.
 */
export const TONE_TEXT: Record<WorkerMetricTone, string> = {
  good: 'text-emerald-400',
  warn: 'text-amber-400',
  bad: 'text-red-400',
  neutral: 'text-gray-200',
};

export const TONE_BAR: Record<WorkerMetricTone, string> = {
  good: 'bg-emerald-500',
  warn: 'bg-amber-500',
  bad: 'bg-red-500',
  neutral: 'bg-gray-500',
};

/** „2 dni temu" zamiast surowego ISO — ten sam format, co reszta panelu. */
export function formatRelativeDate(value: string | null | undefined): string {
  if (!value) return 'Nigdy';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Nigdy';
  const days = Math.floor((Date.now() - date.getTime()) / 86_400_000);
  if (days <= 0) return 'Dzisiaj';
  if (days === 1) return 'Wczoraj';
  if (days < 7) return `${days} dni temu`;
  if (days < 31) return `${Math.floor(days / 7)} tyg. temu`;
  return date.toLocaleDateString('pl-PL');
}
